// @import types
import { IHttpResponse } from 'app_types/httpTypes'
// @end

export enum DocumentProcessorStatus {
  NEW = 'New',
  IN = 'In-process',
  COMPLETE = 'Complete',
  ERROR = 'Error'
}

export enum DocumentProcessorType {
  QUALIFIED_TEACHER = 'Qualified Teacher',
  PORTFOLIO = 'Portfolio'
}

export const DocumentProcessorTypeUrl = {
  "qualified-teacher": DocumentProcessorType.QUALIFIED_TEACHER,
  "Portfolio": DocumentProcessorType.PORTFOLIO
};

export enum DocumentProcessorOptions {
  CARD = 'card',
  JSON = 'json'
}

export interface IDocumentLogs {
  errorLog?: any[],
  processLog?: any[],
}

export interface IDocumentProcessorItem {
  _id: string,
  status?: DocumentProcessorStatus,
  statusLabel?: string,
  type?: DocumentProcessorType,
  typeLabel?: string,
  docPath?: string,
  errorLog?: any[],
  errorLogTutor?: any[],
  processLog?: any[],
  processLogTutor?: any[]
  created_at?: string
  fileUrl?: string
}


export interface IDocumentProcessorResponse extends IHttpResponse {
  documentQueue: IDocumentProcessorItem[]
  total_register: number
  pageNumber: number
  nPerPage: number
}
